import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

const siRoutes = {
  shippingInstructionRoute: () => `v1/shipping-instructions`,
  submitShippingInstruction: () => `v1/shipping-instructions-submit`,
  getContainerSubTypes: () => `v1/container-types`,
  userContactRoute: () => `v1/user-contact`,
  getCommodities: () => `v1/commodities`,
  getPackagesKind: () => `v1/type-of-packages`,
  getUserContactByContactId: (userContactId: any) => `v1/user-contact/${userContactId}`,
  getCountries: () => `v1/countries`,
  deleteSelectedSiDocument: (siDocId: any) => `v1/si-documents/delete/${siDocId}`,
};


const containerDocumentsRoute = {
  containerDocumentRoute: () => `v1/si-container-documents`
};

const siDocumentsRoutes = {
  siDocument: () => `v1/si-documents`
};

export interface ContainerDocumentVO {
  bookingId: string;
  documentTypeId: string;
  siId: number;
  siContainerId: number;

}

@Injectable({
  providedIn: 'root'
})
export class ShippingInstructionService {

  constructor(private http: HttpClient) {
  }

  getShipmentInstructionsByBookingId(bookingId: string) {
    const $shipmentInstruction: Observable<any> = this.http
      .get(siRoutes.shippingInstructionRoute(), {
        params: {
          bookingId
        }
      }).pipe(
        map((x) => {
          return x as any;
        })
      );
    return $shipmentInstruction;
  }

  getContainerSubTypes() {
    const $containerSubTypes: Observable<any> = this.http
      .get(siRoutes.getContainerSubTypes())
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $containerSubTypes;
  }

  getUserContacts(role: string) {
    const $userContacts: Observable<any> = this.http
      .get(siRoutes.userContactRoute(),
        {
          params: {
            role
          }
        })
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $userContacts;
  }

  saveUserContactBasedOnRole(role: string, addressPayload: any) {
    const $userContact: Observable<any> = this.http
      .post(siRoutes.userContactRoute(), addressPayload, {
        params: {
          role
        }
      }).pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $userContact;
  }

  updateSelectedUserContact(userContactVO: any) {
    const $userContact: Observable<any> = this.http
      .put(siRoutes.userContactRoute(), userContactVO).pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $userContact;
  }

  saveDraftSI(bookingId: string, siPayload: any) {
    const $shippingInstruction: Observable<any> = this.http
      .post(siRoutes.shippingInstructionRoute(), siPayload, {
        params: {
          bookingId
        }
      })
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $shippingInstruction;
  }

  updateDraftSI(bookingId: string, siPayload: any) {
    const $shippingInstruction: Observable<any> = this.http
      .put(siRoutes.shippingInstructionRoute(), siPayload, {
        params: {
          bookingId
        }
      })
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $shippingInstruction;
  }

  submitSI(bookingId: string, siPayload: any) {
    const $shippingInstruction: Observable<any> = this.http
      .post(siRoutes.submitShippingInstruction(), siPayload, {
        params: {
          bookingId
        }
      })
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $shippingInstruction;
  }

  getAllUploadDocsBasedOnBookingId(bookingId: string) {
    const $containerDocs: Observable<any> = this.http
      .get(containerDocumentsRoute.containerDocumentRoute(), {
        params: {
          bookingId,
        }
      })
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $containerDocs;
  }

  uploadContainerRelatedDocuments(containerDocumentVO: ContainerDocumentVO, multipartFile: any) {
    const formData = new FormData();
    formData.append('siContainerDocumentRequestVO', JSON.stringify(containerDocumentVO));
    formData.append('multipartFile', multipartFile);
    const $containerRelatedDoc: Observable<any> = this.http
      .post(containerDocumentsRoute.containerDocumentRoute(), formData)
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $containerRelatedDoc;
  }

  updateDocumentByDocId(containerDocId: any, multipartFile: any) {
    const formData = new FormData();
    formData.append('containerDocId', containerDocId);
    formData.append('multipartFile', multipartFile);
    const $containerRelatedDoc: Observable<any> = this.http
      .put(containerDocumentsRoute.containerDocumentRoute(), formData)
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $containerRelatedDoc;
  }

  uploadMultipleSIDocuments(siDocumentVO: any, multipartFiles: any) {
    const formData = new FormData();
    formData.append('siDocumentRequestVO', JSON.stringify(siDocumentVO));
    multipartFiles?.map((x: any) => {
      formData.append('multipartFiles', x);
    });
    const $siRelatedDoc: Observable<any> = this.http
      .post(siDocumentsRoutes.siDocument(), formData)
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $siRelatedDoc;
  }

  getCommodities(prefix: string) {
    const $commodities: Observable<any> = this.http
      .get(siRoutes.getCommodities(), {
        params: {
          prefix,
        }
      })
      .pipe(
        map((x) => {
          return x as any;
        })
      );
    return $commodities;
  }

  getKindOfPackages() {
    const $packages: Observable<any> = this.http
      .get(siRoutes.getPackagesKind())
      .pipe(
        map((x) => {
          return x as any;
        })
      );
    return $packages;
  }

  getUserContactById(userContactId: any) {
    const $userContact: Observable<any> = this.http
      .get(siRoutes.getUserContactByContactId(userContactId))
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $userContact;
  }

  getCountries() {
    const $countries: Observable<any> = this.http
      .get(siRoutes.getCountries())
      .pipe(
        map(
          (x) => {
            return x as any;
          }
        )
      );
    return $countries;
  }

  deleteSelectedSiDocument(siDocId: any) {
    const $siDoc: Observable<any> = this.http
      .delete(siRoutes.deleteSelectedSiDocument(siDocId))
      .pipe(
        map((x) => {
          return x as any;
        })
      );
    return $siDoc;
  }
}
